import Yup from '../../../../vendor/yup';



export const LOCAL_NOTIFICATIONS_CONTENT_TYPE = 'local-notification';

export const mkValidationSchema = (dynamicData = {}) => Yup.lazy(() => {
  return Yup.object().shape({
    template_id: Yup.number().required('Template is required'),
    title: Yup.string().nullable().max(2000),
    is_published: Yup.bool().nullable(),
    ...dynamicData,
  });
});
